<template>
  <section id="page-carts" class="page-carts w-100 h-100">
    <b-table sticky-header 
    style="max-height: 100%" 
    :items="itemPos.listItemCart" :fields="fieldsPos" class="PosTable mb-0 custom-scrollbar" head-variant="light">
      <!-- Cart no data -->
      <template #table-caption>
        <div class="text-center w-100 box-nothing" v-if="itemPos.listItemCart && itemPos.listItemCart.length === 0">
          <div><img src="@/assets/images/box-nothing.png" /></div>
          <div class="text-black-50 font-size-15">Đơn hàng của bạn chưa có sản phẩm nào</div>
        </div>
      </template>
       <!-- Cart data -->
       <template v-slot:head(itemInstance)>
        <span v-if="itemPos.listItemCart">Sản phẩm ({{ itemPos.listItemCart && itemPos.listItemCart.length }})</span>
      </template>

      <template #cell(itemInstance)="data">
        <div class="d-flex">
          <div class="pull-left">
            <img :src="(data.item.images && data.item.images[0]) || defaultImg" />
          </div>
          <div class="item-info">
            <span class="product-name">{{ data.item.itemInstance && data.item.itemInstance.name }}</span>
            <span class="sku text-black-50 font-size-12" v-if="data.item.itemInstance.moreInformation.sku">
              {{ data.item.itemInstance && data.item.itemInstance.moreInformation.sku }}
            </span>
          </div>
        </div>
      </template>

      <template #cell(quantity)="data" class="text-center">
        <span class="numQ" @click="clickPlusSerial(data.item, 'minus')"><i class="el-icon-minus"></i></span>
        <!-- sp co useImeiAndSerial -->
        <number v-model.number="data.item.quantity" v-bind="numFormat" 
        v-if="data.item.useImeiAndSerial" @change="returnNumber(data.item), caculateMoneyPosItem(data.item), caculateMoneyPos(itemPos)"
        @keydown.native="enterKeyMinus($event)"
        disabled="disabled" class="input w-45 text-center"/>
        <!-- sp useProductBatch -->
        <number v-model.number="data.item.quantity" v-bind="numFormat" v-else-if="data.item.useProductBatch" 
        @change="returnNumber(data.item), caculateMoneyPosItem(data.item), caculateMoneyPos(itemPos)"
        @keydown.native="enterKeyMinus($event)" 
        class="input w-45 text-center" :id="`tooltip-target-quantity-${data.index}`"/>    
        <!-- sp khong co serial -->
        <input type="text" min="0" v-model.number="data.item.quantity" v-else @change="keyPressNum(data.item, 'quantity'), returnNumber(data.item), caculateMoneyPosItem(data.item), caculateMoneyPos(itemPos)"
        @keypress="enterKeyFloat($event)"
        class="input w-45 text-center" :id="`tooltip-target-quantity-${data.index}`"
        />
        <b-tooltip v-if="data.item.useProductBatch" :target="`tooltip-target-quantity-${data.index}`" triggers="hover"
          custom-class="tooltip-target-quantity-custom" placement="topleft">
          <div><span class="text-color-200">Có thể bán:</span> <b>{{ data.item.stockQuantity }}</b></div>
        </b-tooltip>
        
        <span class="numQ" @click="clickPlusSerial(data.item, 'plus')"><i class="el-icon-plus"></i></span>
      </template>  

      <template #cell(amount)="data" class="text-center">
          <number v-model.number="data.item.amount" v-bind="numFormat" 
          @change="caculateMoneyPosItem(data.item), caculateMoneyPos(itemPos)" 
          @click.native="changeAmoutInItem(data.item, data.index)"  readonly="readonly" 
          @keydown.native="enterKeyMinus($event)"
          class="input text-right cursor-pointer"/>    
          <div class="text-danger-on tooltip-target-box" :id="`tooltip-target-${data.index}`">
          <span v-if="totalValueBottom(data.item) < 0">-{{ formatMoneyVND(-1 * totalValueBottom(data.item)) }}</span>
          <span v-else-if="totalValueBottom(data.item) > 0">+{{ formatMoneyVND(totalValueBottom(data.item)) }}</span>

          <b-tooltip :target="`tooltip-target-${data.index}`" triggers="hover" custom-class="tooltip-target-custom"
            placement="bottomright">
            <div>
              <span class="text-black-200">Chiết khấu:</span>
              {{ formatMoneyVND(totalDiscountItem(data.item.discount, data.item.typeDiscount, data.item.amount)) }}
            </div>
            <div><span class="text-black-200">Thuế:</span>
              {{ data.item.tax }}%
              <span v-if="data.item.tax > 0">
                ({{ formatMoneyVND(totalTaxItem(data.item.tax, data.item.discount, data.item.typeDiscount, data.item.amount))}})
              </span>
              <span v-else>(0₫)</span>
            </div>
          </b-tooltip>
        </div>
        </template>
      
      <template #cell(totalAmount)="data">
        <div class="text-primary">{{ formatMoneyVND(data.item.totalAmount) }}</div>
      </template>

      <template #cell(deleteItem)="data">
        <div class="text-danger-on fz-24 pointer text-right" @click="deleteItemFromCart(data.item)">
          <i class='bx bx-x'></i>
        </div>
      </template>

      <template #row-details="data">
        <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
        <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
          <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial<span class="text-red">*</span> :</div>
          <div class="col-md-10 pull-left selectDT">
            <el-select 
              @visible-change="(visible) => visible && clickGetListSeri(data.item)" 
              @change="seriesNoChange(data.item)"
              size="medium" class="w-100" 
              multiple 
              v-model="data.item.seriesNoTmp" 
              placeholder="Chọn seri">
              <el-option
                v-for="item in data.item.getSeri"
                :key="item.id"
                :label="item.id"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <!--Chọn số Lo/HSD: useProductBatch-->
        <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
          <div class="col-md-2 text-bold pull-left mt-2">Lô HSD:</div>
          <div class="col-md-10 pull-left selectLoHsd">
            <div class="line-lo-hsd relative" @click="loadDataUseProductBatch(data.index, data.item)">
              <div v-if="data.item.batchTmp.length == 0" class="text-secondary">Chọn Lô, HSD...</div>
              <span class="item-lo-hsd" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                {{ itemBatch.quantityVal }}
                <i class="loHsd bx bx-x" @click.stop="removeItemUseProductBatch(indexBatch, data.index)"></i>
              </span>
              <i class="fa fa-chevron-down icon-right"></i>
            </div>
          </div>
        </div>
      </template>

    </b-table>

    <el-dialog append-to-body
      :title="`Điều chỉnh giá sản phẩm`"
      :visible.sync="openChangeAmoutInItem" class="boxInfoOneItemPos" v-if="openChangeAmoutInItem">
      <div class="content-item-pos-change">
        <div>
          <div class="text-default-100">Đơn giá</div>
          <div>
              <number v-model.number="itemCartPos.amount" v-bind="numFormat" 
              @keydown.native="enterKeyMinus($event)"
              @change="caculateMoneyPosItem(itemCartPos)" class="input w-100"/>
          </div>
        </div>
        <div class="mt-2">
          <div class="text-default-100">Chiết khấu</div>
          <InputMoneyOption class="mb-2" v-model="discountOption"></InputMoneyOption>
        </div>
        <div class="mt-2">
          <div class="text-default-100">Thuế (%)</div>
          <div>
              <number v-model.number="itemCartPos.tax" v-bind="numFormat" 
              @change="changeItemCartPosChangeTax(itemCartPos)"
              @keydown.native="enterKeyMinus($event)"
              :disabled="itemPos.taxOrder > 0" class="input w-100"/>
          </div>
        </div>
      </div>
      <hr class="hr-solid mt-3" />
      <div class="bottom-item-action-chagne mt-3 w-100 text-right">
        <button class="btn btn-default text-primary" @click="openChangeAmoutInItem = false">Thoát</button>
        <button class="btn btn-primary" @click="okChangeAmoutInItem()">Áp dụng</button>
      </div>
    </el-dialog>

    <el-dialog append-to-body title="Chọn lô HSD" width="700px" :visible.sync="openDataUseProductBatch"
      class="boxInfoProductBatch" v-if="openDataUseProductBatch">
      <div class="content-item-pos-change">
        <div>
          <input type="text" class="input w-100" placeholder="Tìm kiếm mã lô" v-model="keySearch"
            @keyup="changeKeySearch" />
        </div>
        <div class="mt-2 scrolTable">
          <table class="w-100">
            <thead>
              <tr>
                <th style="width:25%">Mã lô</th>
                <th style="width:15%">Hạn sử dụng</th>
                <th style="width:20%" class="text-center">Tồn kho</th>
                <th style="width:15%" class="text-center">Số lượng bán</th>
              </tr>
            </thead>
            <tbody v-if="dataBatchItemSearch.length > 0">
              <tr v-for="(item, index) in dataBatchItemSearch" :key="index">
                <td>
                  <input type="text" class="input w-90 disabled" placeholder="Tìm kiếm mã lô" disabled
                    :value="item.batchCode" />
                </td>

                <td :class="item.isExpiration ? 'text-red' : 'text-black'">
                  {{ convertDateItem(item.expirationDate) }}
                  <div v-if="item.isExpiration" class="fz-12">
                    <i>Đã hết hạn</i>
                  </div>
                </td>

                <td class="text-center">{{ item.quantity }}</td>

                <td class="text-center" v-if="item.isExpiration && !checkExpirationDate">
                  <span class="num"><i class="el-icon-minus"></i></span>
                  <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled />
                  <span class="num"><i class="el-icon-plus"></i></span>
                </td>
                <td class="text-center" v-else>
                  <span class="num" @click="clickPlusBatch(item, 'minus')"><i class="el-icon-minus"></i></span>
                    <number v-model.number="item.quantityVal" v-bind="numFormat" v-if="item.quantity > 0" 
                      @change="checkNumbersBatch(item)" 
                      @keydown.native="enterKeyMinus($event)"
                      class="input w-50 text-center"
                    /> 
                    <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled v-else />
                  <span class="num" @click="clickPlusBatch(item, 'plus')"><i class="el-icon-plus"></i></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-black-500 text-center bd-td-head" colspan="4">Không có tìm thấy lô của sản phẩm</td>
              </tr>
            </tbody>
          </table>
          <div class="byExp" v-if="!checkExpirationDate && checkIndexExpiration">Để bán được sản phẩm đã hết hạn sử
            dụng, vui lòng đi tới <a target="_blank" href="/setting/config">Cấu hình bán hàng <i
                class="fa fa-chevron-right fz-12"></i></a></div>
        </div>
        <div class="mt-3 w-100 text-right bdTopBottom">
          <button class="btn btn-default text-primary" @click="openDataUseProductBatch = false">Thoát</button>
          <button class="btn btn-primary" @click="saveDataUseProductBatch">Hoàn tất</button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {fieldsPos, defaultImg, popupAllowedMinus, showMess, numFormat} from "../utils/pos"
import { mapMutations, mapGetters } from "vuex"
import caculateMoneyPosItem from "../mixins/pos"
import enterKeyMinus from "../mixins/pos"
import enterKeyFloat from "../mixins/pos"
import _ from "lodash"
import InputMoneyOption from "./InputMoneyOption.vue";

export default {
  name: "Head",
  props: {
    datas: {
      type: Object,
      default: () => {return {}}
    }
  },
  mixins: [caculateMoneyPosItem, enterKeyMinus, enterKeyFloat],
  components: {InputMoneyOption},
  data() {
    return {
      defaultImg: defaultImg,
      selectMethodPay: "Tiền mặt",
      versionPos: 0,
      amountCustomerPay: 0,
      amountChange: 0,
      fieldsPos: fieldsPos,
      allowedMinus: false,
      itemCartPos: {
        amount: 0,
        tax: 0,
        typeDiscount: '%',
        itemInstance: {
          name: '',
          moreInformation: {
            sku: ''
          }
        }
      },

      numFormat: numFormat,
      openChangeAmoutInItem: false,
     
      itemCartPosIndex: 0,
      openDataUseProductBatch: false,
      dataBatchItem: [],
      dataBatchItemChoose: [],
      keySearch: '',
      dataBatchItemSearch: [],
      lineItemSelect: [],
      indexLineItemSelect: '',
      checkExpirationDate: false,
      checkIndexExpiration: false,
      discountOption: {
        type: "%",
        "%": 0,
        "đ": 0,
      }
    }
  },
  async created() {
    
  },
  computed: {
    ...mapGetters("sell", ["getRmId"]),
  itemPos:{
      get() {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1
        if(index == -1){
          index = 0
          this.SET_RM_ID(index)
        }
        return this.datas.orders[index]
      },
      set(newValue) {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1
        if(index == -1){
          index = 0
          this.SET_RM_ID(index)
        }
        this.datas.orders[index] = newValue
      }
    }
  },
  methods: {
    ...mapMutations("sell", ["SET_LOADING"]),
    clickPlusSerial(item, type) {
      if (!item.useImeiAndSerial) {
        if (type == 'minus') {
          item.quantity--
          item.quantity = (item.quantity < 0) ? 0 : item.quantity
        }
        if (type == 'plus') {
          item.quantity++
        }
        this.returnNumber(item)
        this.caculateMoneyPosItem(item)
        this.caculateMoneyPos(this.itemPos)
      }
    },
    returnNumber(data) {
      //San pham Lo/Hsd
      if (data.useProductBatch) {
        if (data.quantity > data.stockQuantity) {
          data.quantity = data.stockQuantity
          return false
        }
      }
      
      //San pham khac
      if (data.quantity > data.stockQuantity && !this.datas.activeNegativeInv) {
        showMess(this, 'Thông báo', 'Sản phẩm không được bán âm. Sản phẩm này hiện không đủ số lượng trong kho!', 'danger', 'b-toaster-top-right', 1000)
        return (data.quantity = data.stockQuantity)
      }

      if (data.quantity > data.stockQuantity && this.datas.activeNegativeInv) {
        if (this.datas.enableInventory !== false) {
          if (!this.allowedMinus) {
            const resPopup = popupAllowedMinus()
            resPopup.then((result) => {
              if (result.value) {
                this.allowedMinus = true;
              } else {
                return (data.quantity = data.stockQuantity)
              }
            })
          }
        }
      }
    },
    
    deleteItemFromCart(val) {
      this.modalRemoveItemInCartPos = true
      this.itemPos.listItemCart.map((e, index) => {
        if (e.lineItemId === val.lineItemId && e.itemInstance && e.itemInstance.itemVariationId === val.itemInstance.itemVariationId) {
          this.itemPos.listItemCart.splice(index, 1)
        }
      })
      this.caculateMoneyPos(this.itemPos)
    },
    changeAmoutInItem(item, index) {
      this.itemCartPos = _.cloneDeep(item)
      this.itemCartPosIndex = index
      this.resetDiscountOption(item)
      this.openChangeAmoutInItem = true
    },
    resetDiscountOption(item) {
      const type = item.typeDiscount
      const value = item.discount
      this.discountOption.type = type
      this.discountOption[type] = value
    },
    changeItemCartPosChangeTax(itemCartPos){
      itemCartPos.tax = (itemCartPos.tax <= 0) ? 0 : itemCartPos.tax
      itemCartPos.tax = (itemCartPos.tax >= 100) ? 100 : itemCartPos.tax
    },
    okChangeAmoutInItem() {
      if (this.itemPos.listItemCart && this.itemPos.listItemCart[this.itemCartPosIndex]) {
        const type = this.discountOption.type
        const value = this.discountOption[type]

        const item = this.itemPos.listItemCart[this.itemCartPosIndex]
        item.amount = this.itemCartPos.amount
        item.tax = this.itemCartPos.tax
        item.typeDiscount = type
        item.discount = value
        this.openChangeAmoutInItem = false
        this.caculateMoneyPosItem(item)
        this.caculateMoneyPos(this.itemPos)
      }
    },
    totalTaxItem(tax, value_discount, type_discount, value_amount) {
      const total_discount = this.totalDiscountItem(value_discount, type_discount, value_amount)
      const total_real = value_amount - total_discount
      return Math.ceil((tax * total_real) / 100)
    },
    totalDiscountItem(value_discount, type, value_amount) {
      if (type === 'đ') {
        return value_discount
      }
      if (type === '%') {
        return Math.round(value_discount * value_amount / 100)
      }
    },
    totalValueBottom(item) {
      const totalTaxItem = this.totalTaxItem(item.tax, item.discount, item.typeDiscount, item.amount)
      const totalDiscountItem = this.totalDiscountItem(item.discount, item.typeDiscount, item.amount)
      return totalTaxItem - totalDiscountItem
    },
    seriesNoChange(item) {
      item.quantity = item.seriesNoTmp.length
      this.caculateMoneyPosItem(item)
      this.caculateMoneyPos(this.itemPos)
    },
    async clickGetListSeri(item) {
      this.SET_LOADING(true)
      const sku = (item.itemInstance.moreInformation.sku) ? item.itemInstance.moreInformation.sku : ''
      if (sku != '') {
        item.getSeri = await this.getProductSeries(sku)
      }
      this.SET_LOADING(false)
    },
    removeItemUseProductBatch(indexBatch, indexLineItem) {
      this.itemPos.listItemCart[indexLineItem].batchTmp.splice(indexBatch, 1)
      let runTotal = 0
      if (this.itemPos.listItemCart[indexLineItem].batchTmp.length > 0) {
        this.itemPos.listItemCart[indexLineItem].batchTmp.map((item) => {
          if (item.quantityVal > 0) {
            runTotal += item.quantityVal
          }
        })
        this.itemPos.listItemCart[indexLineItem].quantity = runTotal
      } else {
        this.itemPos.listItemCart[indexLineItem].quantity = 0
      }
      this.caculateMoneyPosItem(this.itemPos.listItemCart[indexLineItem])
      this.caculateMoneyPos(this.itemPos)
    },
    async loadDataUseProductBatch(index, item) {
      this.dataBatchItemSearch = []
      this.dataBatchItemChoose = []
      this.openDataUseProductBatch = true
      this.lineItemSelect = item
      this.indexLineItemSelect = index
      const sku = item.itemInstance.moreInformation.sku
      this.checkExpirationDate = await this.getExpiredSale()

      this.dataBatchItem = await this.getProductBatch(sku) //Can thi bo dung them param this.checkExpirationDate

      const getIndexExpiration = this.dataBatchItem.length > 0 ? this.dataBatchItem.findIndex((item) => item.expirationDate == true) : -1
      if (getIndexExpiration) {
        this.checkIndexExpiration = true
      }

      this.changeKeySearch()
    },
    changeKeySearch() {
      const keySearch = this.keySearch.toLowerCase().trim()
      if (keySearch != '') {
        this.dataBatchItemSearch = []
        return this.dataBatchItem.filter((item) => {
          const batchCode = item.batchCode.toLowerCase().trim()
          if (batchCode != '') {
            if (batchCode.includes(keySearch)) {
              this.dataBatchItemSearch.push(item)
            }
          }
        })
      } else {
        this.dataBatchItemSearch = this.dataBatchItem
      }

      const indexLineItem = this.indexLineItemSelect
      this.dataBatchItemSearch.map((item, index) => {
        if (this.itemPos.listItemCart[indexLineItem].batchTmp.length > 0) {
          const indexVal = this.itemPos.listItemCart[indexLineItem].batchTmp.findIndex(e => e.batchCode == item.batchCode)
          if (indexVal != -1) {
            this.dataBatchItemSearch[index].quantityVal = this.itemPos.listItemCart[indexLineItem].batchTmp[indexVal].quantityVal
            this.dataBatchItemChoose.push(this.dataBatchItemSearch[index])
          }
        }
      })
    },
    clickPlusBatch(item, type) {
      if (type == 'minus') {
        item.quantityVal--
        item.quantityVal = (item.quantityVal < 0) ? 0 : item.quantityVal
      }
      if (type == 'plus') {
        item.quantityVal++
        item.quantityVal = (item.quantityVal > item.quantity) ? item.quantity : (item.quantityVal)
      }
      this.checkNumbersBatch(item)
    },
    checkNumbersBatch(item) {
      if (isNaN(item.quantityVal) || item.quantityVal === undefined || item.quantityVal == '') {
        item.quantityVal = 0
        return false
      }
      item.quantityVal = (item.quantityVal > item.quantity) ? item.quantity: item.quantityVal
      if (this.dataBatchItemChoose.length > 0) {
        const indexVal = this.dataBatchItemChoose.findIndex(e => e.batchCode == item.batchCode)
        if (indexVal != -1) {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose[indexVal].quantityVal = item.quantityVal
          } else {
            this.dataBatchItemChoose.splice(indexVal, 1)
          }
        } else {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose.push(item)
          }
        }
      } else {
        if (item.quantityVal > 0) {
          this.dataBatchItemChoose.push(item)
        }
      }
    },
    saveDataUseProductBatch() {
      if (this.dataBatchItemChoose.length > 0) {
        this.itemPos.listItemCart[this.indexLineItemSelect].batchTmp = []
        let runTotal = 0
        this.dataBatchItemChoose.map((item) => {
          if (item.quantityVal > 0) {
            this.itemPos.listItemCart[this.indexLineItemSelect].batchTmp.push(item)
            runTotal += item.quantityVal
          }
        })
        this.itemPos.listItemCart[this.indexLineItemSelect].quantity = runTotal
      } else {
        this.itemPos.listItemCart[this.indexLineItemSelect].quantity = 0
      }
      this.caculateMoneyPosItem(this.itemPos.listItemCart[this.indexLineItemSelect])
      this.caculateMoneyPos(this.itemPos)
      this.openDataUseProductBatch = false
    },
    keyPressNum(parent, key){
      let val = parent[key]
      parent[key] = -1 // vue bị ngu không render lại :))
      val = val.toString().split(".")
      const result = +val.join('.')
      if(typeof result != "number" || isNaN(result))  {
        parent[key] = 1
        return 
      }
      parent[key] = result
    }
  }
}
</script>

<style lang="scss" scoped>
.item-info .product-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
.icon-right {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}
</style>